<adspt-status-icon *ngIf="alert" [color]="color" [size]="size" class="a-fx-inline" />
